import React from 'react';
import { Button, Icon, Stack, Box } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';
import {
  UserCircleIcon,
  UserIcon,
  ArrowRightStartOnRectangleIcon,
} from '@heroicons/react/24/outline';
import { MenuContent, MenuItem, MenuRoot, MenuTrigger, MenuSeparator } from '@/components/ui/menu';
import useCurrentUser from '@/lib/hooks/use-current-user';

interface Props {
  workspaceId?: string;
  handleLogout: () => void;
}

const UserMenu: React.FC<Props> = ({ workspaceId, handleLogout }) => {
  const { user } = useCurrentUser();

  return (
    <MenuRoot lazyMount>
      <MenuTrigger asChild>
        <Button variant={'ghost'} size={'sm'}>
          <Icon as={UserCircleIcon} w={4} h={4} />
          Profile
        </Button>
      </MenuTrigger>
      <MenuContent minW={'250px'}>
        {user && (
          <>
            <MenuItem value='name'>
              <Stack gap={0}>
                <Box display={'block'}>{user.email}</Box>
                <Box fontSize={'xs'} color='fg.muted'>
                  {user?.role?.name}
                </Box>
              </Stack>
            </MenuItem>
            <MenuSeparator />
          </>
        )}
        <MenuItem asChild value='your-profile'>
          <NavLink to={`/${workspaceId}/my/profile`}>
            <Icon as={UserIcon} w={4} h={4} />
            Your Profile
          </NavLink>
        </MenuItem>
        <MenuItem value='sign-out' onClick={() => handleLogout()}>
          <Icon as={ArrowRightStartOnRectangleIcon} w={4} h={4} />
          Log out
        </MenuItem>
      </MenuContent>
    </MenuRoot>
  );
};

export default UserMenu;
